import type { Block } from '../../../types/report';

/** Fallback renderer for any block type without a dedicated component.
 * Renders its data as readable JSON rather than crashing — this is the
 * genre-extensibility contract (unknown kinds must render, not error). */
export function GenericBlock({ block }: { block: Block }) {
  return (
    <pre
      data-generic-block={block.type}
      className="text-xs bg-slate-50 rounded p-3 overflow-auto text-slate-600"
    >
      {JSON.stringify(block.data, null, 2)}
    </pre>
  );
}
